export default "__VITE_ASSET__BOXvBrlo__"